module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-desktop-632597f0d0f5ea9583b215ebcd349e59.webp";